import FormComponent from "../../common/FormComponent";
import React from "react";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import Validators from "../../constants/ValidatorTypes";
import { withSnackbar } from "notistack";
import { getReasonBringingDeceassedById, editReasonBringingDeceassed } from "../../services/reasonBringingDeceased/ReasonBringingDeceasedService";
import ReasonBringingDeceasedForm from "../../components/forms/reasonBringingDeceased/ReasonBringingDeceasedForm";


class EditReasonBringingDeceased extends FormComponent {
  validationList = {
    name: [{ type: Validators.REQUIRED }],
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {

    getReasonBringingDeceassedById(this.props.id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  submit() {

    if (!this.validate()) {
      return;
    }

    this.showDrawerLoader();

    editReasonBringingDeceassed(this.transformRequest(this.state.data)).then(response => {
      if (!response.ok) {
        let messageKey = response.response.data.message;

        this.props.enqueueSnackbar(strings.reasonBringingDeceased.messages[messageKey], {
          variant: "error"
        });

        this.handleError(messageKey);

        return;
      }

      this.props.enqueueSnackbar(strings.reasonBringingDeceased.editForm.edited, { variant: 'success' });
      this.props.onFinish(response.data.reasonBringingDeceased);

      this.hideDrawerLoader();
    });

  }

  transformRequest(data) {
    return {
      ...data,
      userEmail: this.props.uemail,
      companyId: this.props.cid
    }
  }

  handleError(message) {

    switch (message) {
      case "REASON_WITH_NAME_ALREADY_EXIST":
        this.setError("name", strings.reasonBringingDeceased.messages.REASON_WITH_NAME_ALREADY_EXIST);
        break;
      case "REASON_NAME_CANT_BE_NULL":
        this.setError("name", strings.reasonBringingDeceased.messages.REASON_NAME_CANT_BE_NULL);
        break;
      case "REASON_NOT_EXIST":
        this.setError("name", strings.reasonBringingDeceased.messages.REASON_NOT_EXIST);
        break;
    }
  }

  render() {

    return (
      <Grid id="page" item md={12}>
        <div className="header">
          <h1>{strings.aid.editPageTitle}</h1>
        </div>

        <Paper className="paper">
          <ReasonBringingDeceasedForm
            onChange={this.changeData}
            onSubmit={this.submit}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel}
            isDisabled={this.props.isDisabled}
          />
        </Paper>

      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {

  return bindActionCreators(
    {
      changeFullScreen: Actions.changeFullScreen
    },
    dispatch
  );
}

function mapStateToProps({ menuReducers, siteDataReducers }) {

  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(EditReasonBringingDeceased)
  )
);
